var _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8.55228 24 9 23.5523 9 23C9 22.4477 8.55228 22 8 22C7.44772 22 7 22.4477 7 23C7 23.5523 7.44772 24 8 24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C24.5523 24 25 23.5523 25 23C25 22.4477 24.5523 22 24 22C23.4477 22 23 22.4477 23 23C23 23.5523 23.4477 24 24 24Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25.047C4 25.4969 4.29889 25.888 4.73872 25.9826C6.27642 26.3134 10.1702 27 16 27C22.1919 27 25.8541 26.3272 27.2921 25.9927C27.7167 25.894 28 25.5123 28 25.0764V21.5532C28 20.1064 27.04 19 25.76 19H6.24C5.04 19 4 20.1064 4 21.5532V25.047Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.3261V29.3478C9 29.7391 8.66667 30 8.16667 30H6.83333C6.33333 30 6 29.7391 6 29.3478V27",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.3261V29.3478C26 29.7391 25.6667 30 25.1667 30H23.8333C23.3333 30 23 29.7391 23 29.3478V27",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23H20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19L8.30769 14.9518C8.69231 13.7952 9.76923 13 11.0769 13H20.9231C22.1538 13 23.3077 13.7952 23.6923 14.8795L25 18.9277",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 5,
    y2: 17,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 17,
    x2: 25,
    y2: 17,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.99689L15.3651 3.34025C15.7597 3.12783 16.2346 3.12783 16.6291 3.34025L29 10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgParking;